export const SET_SPACE = 'SET_SPACE';

export const RESET_SPACE = 'RESET_SPACE';
